export default function StarIcon() {
  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <title>required field</title>
      <path
        d="M14.5771 7.59615V10.4042L11.0671 10.1702L13.1341 12.9783L10.716 14.4603L9 11.2232L7.28395 14.4603L4.86589 12.9783L6.97195 10.1702L3.42285 10.4042V7.59615L6.97195 7.83015L4.86589 5.02208L7.28395 3.54004L9 6.77713L10.716 3.54004L13.1341 5.02208L11.0671 7.83015L14.5771 7.59615Z"
        fill="#FF6571"
      />
    </svg>
  );
}
